<template>
  <div class="buyxgety-component" :class="model_style">
    <template v-for="(item, index) in data">
      <div class="buyxgety" :key="index" :class="theme" v-if="item">
        <span class="secondary_title">{{ messageType === 'custom' ? customTip(item) : defaultTip(item) }}</span>
        <button data-toggle="modal" @click.prevent="handleShowModle(!buyxgetx ? item : xData)" class="secondary_title">
          {{ messageType === 'custom' ? buttonMessage : $t('buyxgety.button') }}
        </button>
      </div>
    </template>
    <el-dialog custom-class="buyxgetyDialog" :visible.sync="visible" append-to-body>
      <div class="modal-dialog" style="max-width: 416px; margin: 0; min-width: 280px">
        <div class="modal-content" style="max-width: 418px; min-width: 280px">
          <div class="modal-header main_button" style="padding: 0">
            <h5
              class="modal-title title_font2 main_button_color"
              id="exampleModalLabel"
              style="margin: auto; padding-left: 48px"
            >
              {{ $t('buyxgety.giftoffer') }}
            </h5>
            <button
              type="button"
              class="close main_button_color"
              data-dismiss="modal"
              aria-label="Close"
              style="margin: 0; text-shadow: unset; opacity: 1"
              @click="visible = false"
            >
              <span aria-hidden="true" class="iconfont icon-cm-cancel-1-copy"></span>
            </button>
          </div>
          <div class="modal-body" style="margin-bottom: 40px">
            <p class="page_text_font" style="text-align: center">{{ title }}</p>
            <div v-show="load">
              <div class="guess_like" v-if="list.length">
                <div class="guess_list_wrap">
                  <span class="iconfont icon-cm-zuojiantou" @click="prev" v-show="!this.slides == 0"></span>
                  <span class="iconfont icon-cm-youjiantou2" @click="next" v-show="this.slides < this.click_num"></span>
                  <ul @touchstart="startMove" @touchend="endMove" class="buyxgety_list_box clearfix">
                    <li class="guess_list_item" v-for="(item, index) in list" :key="item.ID" style="margin: 0 auto">
                      <div class="item_gallery">
                        <a :href="item.path || item.public_url">
                          <v-lazy-img  v-if="variants[index].feature_image" :data-url="variants[index].feature_image.url" @error.once="imageFailure($event, defaultImage)"></v-lazy-img>
                          <v-lazy-img
                            v-else
                            :data-url="list[index].feature_image && list[index].feature_image.url"
                            :src="list[index].feature_image && list[index].feature_image.thumbnail"
                            @error.once="imageFailure($event, defaultImage)"
                          />
                          <span
                            class="sale_tag saveprice_tag secondary_title"
                            v-if="variants[index].price - 0 < variants[index].regular_price - 0"
                            >-{{
                              100 -
                              Math.round(((variants[index].price - 0) / (variants[index].regular_price - 0)) * 100)
                            }}%</span
                          >
                        </a>
                      </div>
                      <div class="item_name">
                        <a class="page_text_font" :href="item.path || item.public_url" :title="item.post_title">{{
                          item.post_title
                        }}</a>
                      </div>
                      <div
                        class="item_attribute"
                        :class="item.variants_detail && item.variants_detail.length > 1 ? 'has_select' : ''"
                        v-if="item.variants_detail && item.variants_detail.length > 1"
                      >
                        <select
                          name
                          id
                          v-model="addproduct[index].variant_id"
                          @change="selectvariants(item, index)"
                          class="secondary_title"
                        >
                          <option v-for="subitem in item.variants_detail" :key="subitem.ID" :value="subitem.ID">
                            <span
                              v-for="(option, optionindex) in subitem.attrs"
                              :key="subitem.ID + optionindex + option.value"
                              >{{ optionindex == subitem.attrs.length - 1 ? option.value : option.value + '·' }}</span
                            >
                          </option>
                        </select>
                      </div>
                      <p class="item_price">
                        <v-selectprice
                          :price="variants[index].price"
                          :font-size="14"
                          :regular-font-size="14"
                          :regular_price_num="
                            variants[index].price - 0 < variants[index].regular_price - 0
                              ? variants[index].regular_price
                              : 0
                          "
                          :disable_select="true"
                          :currency_style="currency_style"
                          :country="!show_currency_selector ? '' : $store.state.pricetype"
                        ></v-selectprice>
                      </p>

                      <div v-if="!buyxgetx">
                        <button
                          class="item_button minor_button"
                          v-if="variants[index].buy_able"
                          @click="addcart(index)"
                        >
                          <i class="iconfont icon-gouwuche" />
                          <span class="secondary_title text-uppercase">{{ $t('recommend.add_to_cart') }}</span>
                        </button>
                        <button v-else class="item_button" id="slodout">
                          <span class="secondary_title">{{ $t('detail.sold_out') }}</span>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <p class="page_text_font" style="text-align: center; margin: 30px 0" v-else>
                {{ $t('buyxgety.no_products') }}
              </p>
            </div>
            <img v-show="!load" :src="loading" alt width="100%" />
            <p class="page_text_font" style="text-align: center; word-break: initial">{{ $t('buyxgety.steps') }}</p>
            <div class="steps d-flex flex-row justify-content-center align-items-center flex-nowrap">
              <div class="step position-relative d-flex flex-column justify-content-center align-items-center">
                <svg width="25" height="24">
                  <path
                    d="M9.584 17.184c.228 0 .444.042.648.126.204.084.381.201.531.351.15.15.27.327.36.531.09.204.135.42.135.648 0 .228-.045.444-.135.648a1.73 1.73 0 01-.36.531c-.15.15-.327.27-.531.36-.204.09-.42.135-.648.135-.24 0-.462-.045-.666-.135a1.73 1.73 0 01-.531-.36 1.73 1.73 0 01-.36-.531 1.588 1.588 0 01-.135-.648c0-.228.045-.444.135-.648.09-.204.21-.381.36-.531.15-.15.327-.267.531-.351.204-.084.426-.126.666-.126zm7.488.036c.228 0 .447.042.657.126.21.084.39.201.54.351.15.15.27.327.36.531.09.204.135.42.135.648 0 .228-.045.444-.135.648a1.73 1.73 0 01-.36.531c-.15.15-.33.27-.54.36a1.651 1.651 0 01-1.836-.36 1.73 1.73 0 01-.36-.531 1.588 1.588 0 01-.135-.648c0-.228.045-.444.135-.648.09-.204.21-.381.36-.531.15-.15.327-.267.531-.351.204-.084.42-.126.648-.126zm3.024-10.224c.336 0 .597.045.783.135.186.09.318.201.396.333a.756.756 0 01.108.423 1.41 1.41 0 01-.063.387c-.036.108-.114.33-.234.666-.12.336-.249.705-.387 1.107l-.414 1.197c-.138.396-.249.708-.333.936-.156.48-.351.813-.585.999-.234.186-.525.279-.873.279h-9.45l.252 1.62h9.09c.576 0 .864.246.864.738 0 .24-.057.447-.171.621-.114.174-.339.261-.675.261H8.972c-.24 0-.441-.054-.603-.162a1.366 1.366 0 01-.405-.423 2.57 2.57 0 01-.261-.567 5.182 5.182 0 01-.153-.576 26.432 26.432 0 00-.099-.522c-.054-.276-.12-.621-.198-1.035a8635.197 8635.197 0 01-.549-2.925 793.366 793.366 0 00-.774-4.05H4.58a.729.729 0 01-.45-.135 1.175 1.175 0 01-.297-.324 1.247 1.247 0 01-.162-.405 1.954 1.954 0 01-.045-.396.79.79 0 01.243-.594c.162-.156.381-.234.657-.234h1.818c.24 0 .432.036.576.108a.978.978 0 01.522.612l.09.306c.024.096.048.231.072.405l.072.531c.036.216.072.444.108.684h12.312z"
                    fill="#666"
                    fill-rule="nonzero"
                  />
                </svg>
                <div class="explain position-absolute page_text_font" style="padding-left: 0px !important">
                  {{ $t('buyxgety.add') }}
                </div>
              </div>
              <svg width="28" height="6">
                <path
                  d="M24.77.079l.05.037 3 2.5a.5.5 0 01.045.726l-.045.042-3 2.5a.5.5 0 01-.686-.725l.046-.043L26.118 3.5H.5a.5.5 0 01-.058-.997L.5 2.5h25.619L24.179.884a.5.5 0 01-.1-.653l.037-.051a.5.5 0 01.6-.131l.053.03z"
                  fill="#666"
                  fill-rule="nonzero"
                />
              </svg>
              <div class="step position-relative d-flex flex-column justify-content-center align-items-center">
                <svg width="24" height="24">
                  <path
                    d="M12 3a9 9 0 100 18 9 9 0 000-18zm3.52 5.166l-2.022 3.115h1.114a.64.64 0 01.638.638.64.64 0 01-.638.638h-1.856v.525h1.857a.64.64 0 01.637.638.64.64 0 01-.638.638h-1.856v1.914a.674.674 0 01-.671.671h-.135a.673.673 0 01-.671-.671v-1.914H9.44a.64.64 0 01-.638-.638.64.64 0 01.638-.638h1.838v-.525H9.44a.64.64 0 01-.638-.638.64.64 0 01.638-.638h1.06L8.48 8.166a.673.673 0 01.198-.929l.112-.073a.674.674 0 01.93.198l2.28 3.513 2.283-3.513a.674.674 0 01.929-.198l.112.073c.31.203.399.618.198.93z"
                    fill="#666"
                    fill-rule="nonzero"
                  />
                </svg>
                <div class="explain position-absolute page_text_font">{{ $t('buyxgety.checkout') }}</div>
              </div>
              <svg width="28" height="6">
                <path
                  d="M24.77.079l.05.037 3 2.5a.5.5 0 01.045.726l-.045.042-3 2.5a.5.5 0 01-.686-.725l.046-.043L26.118 3.5H.5a.5.5 0 01-.058-.997L.5 2.5h25.619L24.179.884a.5.5 0 01-.1-.653l.037-.051a.5.5 0 01.6-.131l.053.03z"
                  fill="#666"
                  fill-rule="nonzero"
                />
              </svg>
              <div class="step position-relative d-flex flex-column justify-content-center align-items-center">
                <svg width="25" height="24">
                  <path
                    d="M11.793 6.717v3.97H3.5V7.5c0-.501.404-.903.91-.903h3.779c-1.015-.21-1.776-.642-1.804-1.437-.029-.939 1.037-2.455 2.593-2.108 1.607.359 2.729 1.593 3.588 2.65.868-1.079 2.097-2.468 3.774-2.687 1.401-.175 2.56 1.213 2.41 2.13-.128.803-.902 1.24-1.891 1.451h3.731c.506 0 .91.402.91.903v3.186h-8.293l-.018-4.012m-4.04-2.79c-.775-.304-1.23.022-1.556.557-.178.303-.369.706-.086 1 .746.763 2.792.706 4.165.565-.647-.803-1.442-1.699-2.523-2.122zm8.478 1.552c.533-.677-.512-2.087-1.634-1.565-1.073.5-1.848 1.318-2.515 2.122.575.05 1.157.063 1.734.035.703-.029 2.004-.077 2.415-.592zM11.85 20.217H5.09a.822.822 0 01-.824-.824V11.33h7.585v8.888h-.001zm8.883-.825a.822.822 0 01-.825.824H13.15v-8.888h7.583v8.064z"
                    fill="#666"
                    fill-rule="nonzero"
                  />
                </svg>
                <div class="explain position-absolute page_text_font" style="padding-right: 0px !important">
                  {{ $t('buyxgety.Enjoy') }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import loading from '@/images/shareloading.png'
// import API from '../../../API'
import googleAnalysis from '@/js/lib/ga'
import { mapState } from 'vuex'

export default {
  props: [
    'buyxgety_coupon',
    'getSymbolFromCurrency',
    'show_currency_selector',
    'cart_type',
    'currency_style',
    'theme',
    'add_cart_data',
    'model_style', // 值为hide_top_border隐藏上border margin padiing
    'buyxgetySetting',
  ],
  data() {
    return {
      title: null,
      list: [],
      addproduct: [],
      variants: [],
      // defaultImage,
      slides: 0,
      buyxgety_list_box: 0, //ul盒子宽度
      guess_list_item: 0, //li宽度
      box_left: 0, //当前left值
      base_num: 2, //每次展示个数
      click_num: 0, //列表数量/每次展示个数-1等于可点击次数
      offset_num: 0, //超过可点击次数后展示偏移展示位置
      startX: 0,
      endX: 0,
      data: [],
      loading,
      load: false,
      visible: false,
      current_page: 1, //当前优惠api页数，
      last_page: 1, //api总页数
      preference_type: 'count',
      buyxgetx: null,
      xData: {},
      messageType: this.buyxgetySetting?.show_message_type || 'default', // 满送优惠默认defualt 自定义文本custom
      buttonMessage: this.buyxgetySetting?.button_message || null, // 查看赠送商品按钮文本
      countDiscountMessage: this.buyxgetySetting?.show_discount_message || null, //满件赠送折扣方式为免费时的提示文本
      countFreeMessage: this.buyxgetySetting?.show_message || null, //满件赠送折扣方式为百分比时的提示文本
      amountFreeMessage: this.buyxgetySetting?.show_amount_message || null, //满额赠送折扣方式为免费时的提示文本
      amountDiscountMessage: this.buyxgetySetting?.show_amount_discount_message || null, //满额赠送折扣方式为百分比时的提示文本
      preference_type: 'count', // 优惠类型：amount满额 count满件
    }
  },
  methods: {
    prev() {
      this.slides--
      this.complete_num()
      if (this.slides <= 0) {
        this.$('.buyxgety_list_box').animate(
          {
            left: '0px',
          },
          300
        )
        this.slides = 0
      } else {
        this.$('.buyxgety_list_box').animate(
          {
            left: `${this.box_left + this.buyxgety_list_box}px`,
          },
          300
        )
      }
    },
    complete_num() {
      this.buyxgety_list_box = this.$('.buyxgety_list_box').width()
      this.guess_list_item = this.$('.guess_list_item').innerWidth()
      this.box_left = this.$('.buyxgety_list_box').position().left
      this.click_num = Math.ceil(this.list.length / this.base_num) - 1 //列表数量/每次展示个数-1等于可点击次数
      this.offset_num = this.list.length % this.base_num //超过可点击次数后展示偏移展示位置
    },
    next() {
      this.slides++
      this.complete_num()
      if (this.current_page < this.last_page && this.click_num - this.slides < 5) {
        this.current_page++
        this.$nextTick(() => {
          this.fetch()
        })
      }
      if (this.slides <= this.click_num) {
        this.$('.buyxgety_list_box').animate(
          {
            left: `${this.box_left - this.buyxgety_list_box}px`,
          },
          300
        )
      } else {
        this.$('.buyxgety_list_box').animate(
          {
            left: `${this.box_left - this.buyxgety_list_box + this.offset_num * this.guess_list_item}px`,
          },
          300
        )
      }
    },
    async fetch() {
      try {
        let res = await this.$axios.post('/api/store/products/search', {
          include_id: this.playload,
          page_size: 25,
          page: this.current_page,
        })
        let { data } = res
        this.last_page = data.meta.last_page
        this.list = [...this.list, ...data.data]
        this.variants = []
        this.addproduct = []
        this.list.forEach((item) => {
          if (item.variants_detail && item.variants_detail.length) {
            this.variants.push(item.variants_detail[0])
            this.addproduct.push({
              quantity: '1',
              product_id: item.ID,
              variant_id: item.variants_detail[0].ID,
            })
          } else {
            this.addproduct.push({
              quantity: '1',
              product_id: item.ID,
            })
            this.variants.push(item)
          }
        })
        if (this.list.length) {
          this.$nextTick(this.complete_num)
        }
        this.load = true
      } catch (error) {
        if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message)
        }
      }
    },
    handleShowModle(e) {
      // this.$("#buyxgety").modal("show");
      this.visible = true
      this.list = []
      this.$('.buyxgety_list_box').animate(
        {
          left: 0,
        },
        300
      )
      this.slides = 0
      this.title = this.messageType === 'custom' ? this.customTip(e) : this.defaultTip(e)
      this.playload = []
      this.current_page = 1
      this.load = false
      for (const item in e.product_variants) {
        let obj = {
          product_id: item,
          variant_id: e.product_variants[item],
        }
        this.playload.push(obj)
      }
      this.fetch()
    },
    async addcart(index) {
      try {
        let res = await this.$axios.post(API.addcart, {...this.addproduct[index],addType:'buyxgety'})
        // this.$("#buyxgety").modal("hide");
        this.visible = false
        if (window.fbq) {
          let content_category = []
          if (this.list[index].categories && this.list[index].categories.length) {
            this.list[index].categories.forEach((item) => {
              content_category.push(item.name)
            })
          }
          this.send_fb_event('AddToCart', {
            content_type: 'product_group',
            content_ids: [this.addproduct[index].product_id],
            value: this.variants[index].price,
            num_items: this.addproduct[index].quantity,
            content_name: this.variants[index].title,
            currency: window.checkoutcurrency || 'USD',
            content_category,
          })
        }
        if (window.ttq && window.send_ttp_event) {
          window.send_ttp_event('AddToCart', {
            content_id: [this.addproduct[index].product_id],
            quantity: this.addproduct[index].quantity,
            value: this.variants[index].price,
            currency: window.checkoutcurrency || 'USD',
          })
        }
        if (window._learnq) {
          this.klaviyo_addtocart(this.list[index], this.addproduct[index])
        }
        if (window.snaptr) {
          window.snaptr('track', 'ADD_CART', {
            currency: window.checkoutcurrency || 'USD',
            item_category: null,
            item_ids: [this.addproduct[index].product_id],
            number_items: this.addproduct[index].quantity,
            price: this.variants[index].price,
          })
        }
        // if (window.gtag) {
        //   window.gtag("event", "add_to_cart");
        // }
        // 添加到购物车
        googleAnalysis.event(googleAnalysis.gaAction.add)

        this.$store.dispatch('cartContentsCount', res.data.cart_contents_count)
        localStorage.setItem('cartContentsCount', res.data.cart_contents_count)
        this.$store.dispatch('change_news_cart', res.data)
        if(res.data){
          this.$store.commit("change_button_disabled", true);
        }
        if (this.theme == 'athena') {
          this.$('.buy_animate').addClass('buy_animate_action')
          if (parseInt(this.$('#app').css('padding-left')) > 0) {
            this.$('.site-header').addClass('add_cart_animate_has_quicknav')
          } else {
            this.$('.site-header').addClass('add_cart_animate')
          }
          return
        }
        if ((this.theme == 'default' || this.theme == 'showtime') && this.cart_type == 'drawer') {
          if (this.theme == 'default') {
            this.$store.dispatch('change_cart_type', true)
            this.$store.commit("change_button_disabled", false);
          }
          if (this.theme == 'showtime') {
            document.body.scrollTop = document.documentElement.scrollTop = 0
            this.$('#collapseExample').collapse('show')
          }
        } else if ((this.theme == 'venue' || this.theme == 'showtime') && this.cart_type == 'popup') {
          setTimeout(() => {
            this.$('#modalCart').modal('show')
          }, 500)
          // this.$nextTick(()=>{

          // })
          //  event.stopPropagation();
        } else if (this.theme == 'vogue' && (this.cart_type == 'popup' || this.cart_type == 'drawer')) {
          this.showInlineCart()
        } else {
          if(this.theme !== 'default'){
            window.open('/cart', '_self')
          }
        }
        setTimeout(() => {
          this.$store.commit("change_button_disabled", false);
        }, 800)
      } catch (error) {
        // this.loading = false;
        this.$store.commit("change_button_disabled", false);
        if (error?.response?.data?.errors) {
          this.$message.error(Object.values(error.response.data.errors)[0][0])
        } else if (error?.response?.data?.message) {
          this.$message.error(error.response.data.message)
        }
      }
    },
    selectvariants(item, index) {
      if (this.list[index].variants_detail) {
        this.list[index].variants_detail.some((item) => {
          if (item.ID == this.addproduct[index].variant_id) {
            this.variants.splice(index, 1, item)
            return true
          }
        })
      }
    },
    startMove(e) {
      this.startX = e.targetTouches[0].clientX // 获取触控时x坐标
    },
    endMove(e) {
      this.endX = e.changedTouches[0].clientX
      if (this.distance > 50) {
        this.prev()
      } else if (this.distance < -50 && this.slides < this.click_num) {
        this.next()
      }
    },
    defaultTip(e) {
      const { free_type, from, free_value, free_qty } = e
      let tip = null
      switch (this.preference_type) {
        case 'amount':
          if (free_type == 'percentage') {
            tip = this.$t('buyxgety.amount_tip1', {
              from: `${this.priceSymbol}${this.computePrice(from, false, false, 'auto')}`,
              free_qty,
              free_value,
            })
          }
          if (free_type == 'free_product') {
            tip = this.$t('buyxgety.amount_tip2', {
              from: `${this.priceSymbol}${this.computePrice(from, false, false, 'auto')}`,
              free_qty,
            })
          }
          break
        default:
          if (free_type == 'percentage') {
            tip = this.$t('buyxgety.tip1', { from, free_qty, free_value })
          }
          if (free_type == 'free_product') {
            tip = this.$t('buyxgety.tip2', { from, free_qty })
          }
          break
      }
      return tip
    },
    customTip(e) {
      const { free_type, from, free_value, free_qty } = e
      let tip = ''
      switch (this.preference_type) {
        case 'amount':
          if (free_type == 'percentage') {
            // 2. 买n件享受x件商品z折优惠：
            tip = this.amountDiscountMessage || ''
            tip = tip.replace(/\{\{\$fullAmount_discount\}\}/g, `${free_value}%`)
          }
          if (free_type == 'free_product') {
            // 1.买n件送x件免费商品：
            tip = this.amountFreeMessage || ''
          }
          tip = tip.replace(/\{\{\$buyAmount\}\}/g, `${this.priceSymbol}${from}`)
          tip = tip.replace(/\{\{\$fullAmount_getItem\}\}/g, free_qty)
          break
        default:
          if (free_type == 'percentage') {
            // 2. 买n件享受x件商品z折优惠：】
            tip = this.countDiscountMessage || ''
            tip = tip.replace(/\{\{\$fullItem_discount\}\}/g, `${free_value}%`)
          }
          if (free_type == 'free_product') {
            // 1.买n件送x件免费商品：
            tip = this.countFreeMessage || ''
          }
          tip = tip.replace(/\{\{\$buyItem\}\}/g, from)
          tip = tip.replace(/\{\{\$fullItem_getItem\}\}/g, free_qty)
          break
      }
      return tip
    },
    find_data(product_id, variant_id) {
      this.buyxgety_coupon.some((item) => {
        return item.product_ids[0].real_value.some((id) => {
          if (id - 0 == product_id - 0 || id - 0 == variant_id - 0) {
            this.data = item.discount_rule
            this.preference_type = item.preference_type
            this.buyxgetx = item.discount_type === 'wdr_buy_x_get_x_discount'
            this.xData = item.product_ids[0]
            return true
          } else {
            this.data = []
          }
        })
      })
    },
  },
  beforeMount() {},
  mounted() {},
  computed: {
    // 手指触碰与离开的差值
    distance() {
      return this.endX - this.startX
    },
    ...mapState({
      // 用户选择的货币符号
      priceSymbol: ({ priceSymbol }) => priceSymbol,
    }),
  },
  watch: {
    add_cart_data: {
      deep: true,
      immediate: true,
      handler(value) {
        const { product_id, variant_id } = value
        this.find_data(product_id, variant_id)
      },
    },
  },
}
</script>

<style lang='scss'>
.buyxgetyDialog {
  background: unset;
  max-width: 416px;
  min-width: 280px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
  }

  .guess_like {
    margin: 20px 0;
    position: relative;
    .guess_list_wrap {
      & > span {
        margin: 0;
        padding: 0;
        position: absolute;
        cursor: pointer;
        left: auto;
        width: 20px;
        height: 32px;
        background: #f2f2f2;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        color: #666;
        top: 80px;
        z-index: 99;
      }
      & > span:nth-child(1) {
        left: 0;
      }
      & > span:nth-child(2) {
        right: 0;
      }
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      padding: 0;
      .buyxgety_list_box {
        margin: 0;
        padding: 0;
        position: relative;
        z-index: 1;
        box-sizing: content-box;
        outline: 0;
        display: flex;
        left: 0px;
        .guess_list_item {
          flex-shrink: 0;
          list-style: none;
          width: 50%;
          padding: 8px;
          box-sizing: border-box;
          text-align: center;
          display: flex;
          flex-direction: column;

          .item_gallery {
            width: 100%;
            position: relative;
            box-sizing: border-box;
            // height: 211px;
            margin-bottom: 8px;

            padding-top: 100%;
            a {
              position: absolute;
              top: 0;
              left: 0;

              margin: 0;
              padding: 0;
              text-decoration: none;
              -webkit-tap-highlight-color: transparent;
              outline: 0;
              display: flex;
              height: 100%;
              width: 100%;
              justify-content: center;
              align-items: center;
              img {
                max-width: 100%;
                max-height: 100%;
                display: block;
                margin: 0 auto;
              }
            }
            .sale_tag {
              position: absolute;
              right: 0;
              top: 0;
              padding: 6px 12px;
              color: #fff;
              font-size: 12px;
              line-height: 14px;
              text-align: center;
              z-index: 1;
              background: #333;
            }
          }

          .item_name {
            margin: 0 auto;
            margin-bottom: 8px;
            width: 100%;
            a {
              color: #666;
              font-size: 14px;
              text-decoration: none;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .oneline {
              display: inline-block;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .item_attribute {
            width: 100%;
            color: #737373;
            height: 24px;
            margin-bottom: 8px;
            select {
              width: 100%;
              height: 100%;
              border: 1px solid #dfdfdf;
              padding: 0 25px 0 10px;
              box-sizing: border-box;
              z-index: 1;
              position: relative;
              color: #737373;
              border-radius: 4px;
              outline: 0;
              appearance: none;
              -webkit-appearance: none;
            }
          }
          .has_select {
            position: relative;
            &::after {
              font-family: iconfont !important;
              -webkit-font-smoothing: antialiased;
              content: '\E63C';
              font-size: 14px;
              position: absolute;
              right: 5px;
              top: 50%;
              transform: translateY(-50%);
              z-index: 999;
              pointer-events: none;
            }
          }
          .item_price {
            text-align: center;
            margin: 0 auto;
            margin-bottom: 26px;
            padding: 0;
            .price {
              font-size: 14px;
              margin: 0 2px;
              font-weight: 700;
            }
            .regular_price {
              font-size: 14px;
              margin: 0 2px;
              text-decoration: line-through;
              color: rgb(123, 119, 130);
              display: inline-block;
            }
          }
          .item_star {
            -webkit-tap-highlight-color: transparent;
            height: 18px;
            display: inline-flex;
            justify-content: left;
            align-items: center;
            margin: 0 auto;
            margin-bottom: 8px;
          }
          .item_button {
            display: inline-block;
            line-height: 1;
            cursor: pointer;
            background: #fff;
            border: 1px solid #dcdfe6;
            -webkit-appearance: none;
            text-align: center;
            box-sizing: border-box;
            outline: 0;
            transition: 0.1s;
            font-weight: 500;
            border-radius: 4px;
            font-family: LatoRegular !important;
            color: rgba(0, 0, 0, 1);
            border-color: rgba(0, 0, 0, 1);
            background-color: rgba(255, 255, 255, 1);
            margin: 0 auto;
            margin-bottom: 8px;
            padding: 10px 0;
            width: 100%;
            font-size: 14px;
          }
          #slodout {
            background-color: #969696 !important;
            border-color: #969696 !important;
            color: white !important;
            cursor: default !important;
          }
        }
      }
    }
  }

  .steps {
    .step {
      width: 28px;
      overflow: visible;
      margin: 0px 10px;
      .page_text_font {
        padding-left: 7.5px !important;
        padding-right: 7.5px !important;
        //@debugwhite-space: pre-wrap;
        word-wrap: break-word;
        word-break: initial;
        font-size: 12px !important;
      }
    }
    .explain {
      top: 25px;
      left: 50%;
      transform: translateX(-50%) scale(0.8);
      transform-origin: center center;
      width: 100px;
      line-height: 1.3;
      font-size: 12px;
      color: #666;
      white-space: normal;
      text-align: center;
    }
  }
}
</style>

<style scoped lang='scss'>
.buyxgety-component {
  text-align: left;
  margin: 10px 0;
  .modal-dialog {
    margin-top: 100px;
  }
  .buyxgety {
    width: 100%;
    line-height: 36px;
    border-bottom: 1px solid #ddd;
    padding: 8px 0;
    p {
      margin: 0;
    }
    button {
      display: inline-block;
      color: red;
      background: rgb(255, 246, 216);
      border: none;
    }
  }

  .default {
    max-width: 400px;
    margin: 0 auto;
  }

  .showtime {
    max-width: 350px;
  }

  .venue {
    text-align: left;
  }

  .buyxgety:first-of-type {
    border-top: 1px solid #ddd;
  }

  .guess_like {
    margin: 20px 0;
    position: relative;
    .guess_list_wrap {
      & > span {
        margin: 0;
        padding: 0;
        position: absolute;
        cursor: pointer;
        left: auto;
        width: 20px;
        height: 32px;
        background: #f2f2f2;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        color: #666;
        top: 80px;
        z-index: 99;
      }
      & > span:nth-child(1) {
        left: 0;
      }
      & > span:nth-child(2) {
        right: 0;
      }
      margin: 0 auto;
      position: relative;
      overflow: hidden;
      padding: 0;
      .buyxgety_list_box {
        margin: 0;
        padding: 0;
        position: relative;
        z-index: 1;
        box-sizing: content-box;
        outline: 0;
        display: flex;
        left: 0px;
        .guess_list_item {
          flex-shrink: 0;
          list-style: none;
          width: 50%;
          padding: 8px;
          box-sizing: border-box;
          text-align: center;
          display: flex;
          flex-direction: column;

          .item_gallery {
            width: 100%;
            position: relative;
            box-sizing: border-box;
            // height: 211px;
            margin-bottom: 8px;

            padding-top: 100%;
            a {
              position: absolute;
              top: 0;
              left: 0;

              margin: 0;
              padding: 0;
              text-decoration: none;
              -webkit-tap-highlight-color: transparent;
              outline: 0;
              display: flex;
              height: 100%;
              width: 100%;
              justify-content: center;
              align-items: center;
              img {
                max-width: 100%;
                max-height: 100%;
                display: block;
                margin: 0 auto;
              }
            }
            .sale_tag {
              position: absolute;
              right: 0;
              top: 0;
              padding: 6px 12px;
              color: #fff;
              font-size: 12px;
              line-height: 14px;
              text-align: center;
              z-index: 1;
              background: #333;
            }
          }

          .item_name {
            margin: 0 auto;
            margin-bottom: 8px;
            width: 100%;
            a {
              color: #666;
              font-size: 14px;
              text-decoration: none;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
            }
            .oneline {
              display: inline-block;
              width: 100%;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .item_attribute {
            width: 100%;
            color: #737373;
            height: 24px;
            margin-bottom: 8px;
            select {
              width: 100%;
              height: 100%;
              border: 1px solid #dfdfdf;
              padding: 0 25px 0 10px;
              box-sizing: border-box;
              z-index: 1;
              position: relative;
              color: #737373;
              border-radius: 4px;
              outline: 0;
              appearance: none;
              -webkit-appearance: none;
            }
          }
          .has_select {
            position: relative;
            &::after {
              font-family: iconfont !important;
              -webkit-font-smoothing: antialiased;
              content: '\E63C';
              font-size: 14px;
              position: absolute;
              right: 5px;
              top: 50%;
              transform: translateY(-50%);
              z-index: 999;
              pointer-events: none;
            }
          }
          .item_price {
            text-align: center;
            margin: 0 auto;
            margin-bottom: 26px;
            padding: 0;
            .price {
              font-size: 14px;
              margin: 0 2px;
              font-weight: 700;
            }
            .regular_price {
              font-size: 14px;
              margin: 0 2px;
              text-decoration: line-through;
              color: rgb(123, 119, 130);
              display: inline-block;
            }
          }
          .item_star {
            -webkit-tap-highlight-color: transparent;
            height: 18px;
            display: inline-flex;
            justify-content: left;
            align-items: center;
            margin: 0 auto;
            margin-bottom: 8px;
          }
          .item_button {
            display: inline-block;
            line-height: 1;
            cursor: pointer;
            background: #fff;
            border: 1px solid #dcdfe6;
            -webkit-appearance: none;
            text-align: center;
            box-sizing: border-box;
            outline: 0;
            transition: 0.1s;
            font-weight: 500;
            border-radius: 4px;
            font-family: LatoRegular !important;
            color: rgba(0, 0, 0, 1);
            border-color: rgba(0, 0, 0, 1);
            background-color: rgba(255, 255, 255, 1);
            margin: 0 auto;
            margin-bottom: 8px;
            padding: 10px 0;
            width: 100%;
            font-size: 14px;
          }
          #slodout {
            background-color: #969696 !important;
            border-color: #969696 !important;
            color: white !important;
            cursor: default !important;
          }
        }
      }
    }
  }

  .steps {
    .step {
      width: 28px;
      overflow: visible;
      margin: 0px 10px;
    }
    .explain {
      top: 28px;
      left: 50%;
      transform: translateX(-50%) scale(0.8);
      transform-origin: center center;
      width: 100px;
      line-height: 1.3;
      font-size: 12px;
      color: #666;
      white-space: normal;
      text-align: center;
    }
  }
}
.hide_top_border {
  margin-top: 0;
  @media screen and(min-width: 768px) {
    .buyxgety:first-child {
      padding-top: 0;
      border-top: none !important;
    }
  }
}

@media screen and(max-width: 575px) {
  .buyxgety-component {
    .modal-dialog {
      margin-top: 0;
    }
    .buyxgety {
      button {
        display: inline-block;
      }
    }
    .showtime {
      line-height: 36px;
      button {
        display: inline-block;
      }
    }
  }
}
@media screen and(max-width: 768px) {
  //满送优惠弹窗标题移动端
  #exampleModalLabel {
    text-align: center;
    word-break: break-word;
    font-size: 18px !important;
  }
  ::v-deep{
   button .icon-gouwuche{
     display: none;
   }
  }
}
</style>
